import styled from "styled-components"

import Image from "gatsby-image"

export let ImageStyled = ``
export const Wrapper = styled.article`
  width: 100%;
  height: 100%;
  display: grid;
  
  &:hover ${ImageStyled}::after {
    opacity: 0;
  }
  
  @media (min-width: 992px) {
    grid-template-columns: repeat(12, 1fr);
    align-items: center;
    padding:2rem 0;
    border-radius:20px;
    margin-bottom: 4rem;
    margin-top: 4rem;
    margin-bottom: 5rem;
    /* border:1px dotted rgba(0, 0, 0, 0.2); */
  }
`

ImageStyled = styled(Image)`
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
  width: 100%;
  height: 30rem;
  z-index: 1;
  position: relative;
  transition: var(--transition);

  &:hover {
    z-index: 2;
  }
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom right, var(--clr-primary-5), #222);
    opacity: 0.3;
    transition: var(--transition);
  }

  @media screen and (min-width: 576px) {
    height: 19rem;
  }
  @media screen and (min-width: 768px) {
    height: 22rem;
  }

  @media screen and (min-width: 992px) {
    justify-content: center;
    align-items: center;
    width: 100%;
    grid-column: 1 / span 8;
    grid-row: 1 / 1;
    height: 33rem;
    border-radius: var(--radius);
    box-shadow: var(--dark-shadow);

    ${Wrapper}:nth-of-type(even) & {
      grid-column: 5 / -1;
      grid-row: 1 / 1;
    }
  }
`

export const Info = styled.div`
  background: ${({ theme }) => theme.contentBackground};
  padding: 1.5rem 2rem;
  min-height: 19rem;
  border-bottom-left-radius: var(--radius);
  border-bottom-right-radius: var(--radius);
  position: relative;

  @media (min-width: 992px) {
    border-radius: var(--radius);
    box-shadow: var(--dark-shadow);

    z-index: 1;
    grid-column: 5 /12;
    grid-row: 1 / 1;

    ${Wrapper}:nth-of-type(even) & {
      grid-column: 2 / span 7;
      grid-row: 1 / 1;
      text-align: left;
    }
  }
`

export const Header = styled.h3`
  font-weight: 500;
  margin-bottom: 1.3rem;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.headerColor};
`
export const SubHeader = styled.h4`
  font-weight: 400;
  margin-bottom: 1.1rem;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.headerColor};
`
export const Number = styled.span`
  position: absolute;
  bottom: 15px;
  right: -30px;
  font-size: 2rem;
  padding: 1px 4px;
  color: var(--clr-primary-5);
  border-radius: 100px;
  background: ${({ theme }) => theme.contentBackground};

  @media (max-width: 992px) {
    right: -14px;
    font-size: 1.5rem;
    padding: 1px 3px;
  }
`

export const Text = styled.p`
  line-height: 1.5rem;
  color: ${({ theme }) => theme.contentColor};
`
export const Tags = styled.section`
  margin-bottom: 1rem;
  & span {
    display: inline-block;
    background: ${({ theme }) => theme.tagBackground};
    color: ${({ theme }) => theme.tagColor};
    margin-right: 0.5rem;
    margin-top: 0.5rem;
    padding: 0.25rem 0.5rem;
    border-radius: var(--radius);
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 0.8rem;
  }
`
export const ProjectLink = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;

  & .project-icon {
    color: ${({ theme }) => theme.buttonColor};
    font-size: 1rem;
  }
  @media (max-width: 300px) {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: start;
    align-items: start;
  }
`
export const Button = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 34px;
  padding: 0px 4px;
  margin-right: 1rem;
  border: 2px solid ${({ theme }) => theme.buttonColor};
  border-radius: 0 0 12px 0;
  transition: var(--transition);

  & span {
    margin-right: 0.5rem;
    color: ${({ theme }) => theme.buttonColor};
    font-size: 0.8rem;
    text-transform: uppercase;
    font-weight: 700;
  }
  &:hover {
    background-color: ${({ theme }) => theme.buttonColor};
    & span {
      color: white;
    }
  }
  &:hover .project-icon {
    color: white;
  }

  @media (max-width: 500px) {
    padding: 0px 4px;
    height: 30px;
    & span {
      margin-right: 0.3rem;
      font-size: 0.6rem;
      text-transform: uppercase;
      font-weight: 500;
    }
    & .project-icon {
      font-size: 0.7rem;
    }
  }

  @media (max-width: 360px) {
    padding: 0px 2px;
    height: 30px;
    & span {
      margin-right: 0.2rem;
      font-size: 0.5rem;
      font-weight: 400;
    }
    & .project-icon {
      font-size: 0.5rem;
    }
  }

  @media (max-width: 300px) {
    height: 25px;
    margin-right: 0rem;
    margin-left: 0rem;

    margin-top: 0.5rem;
  }
`

export const ImageStyle = {
  height: `100%`,
  width: `100%`,
  backgroundColor: `transparent`,
  backgroundSize: `cover`,
  backgroundPosition: `center center`,
  display: `flex`,
  alignItems: `center`,
  justifyContent: "center",
}
